/**
 * Checks if a value is null or undefined.
 * @param {*} value - The value to check
 * @returns {boolean} True if null or undefined
 */
export const isDataNull = (value) => value === null || value === undefined;

/**
 * Safely parses a value to integer, returning null for invalid values.
 * @param {*} value - The value to parse
 * @returns {number|null} Parsed integer or null
 */
export const parseIntOrNull = (value) => {
  if (!value && value !== 0) return null;
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) return null;
  return parsed;
};
